// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__LNzPi","unreadBadge":"styles_unreadBadge__1TiDM","modalContent":"styles_modalContent__1khoK","modal":"styles_modal__1Sd7x"};